import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MicrosoftDriveService {

	id: string = 'b!PsE39oVY7E-mknXVWssRlfUrlqeZwnFNtrbMIDxxcppzfl4SmRkSQZvuLQUHPKIG';

	constructor() { }

	static withLink (item: {name: string, parentReference: any, link?}): any {		
		return {
			...item,
			link: ['/drive', ...`${(item.parentReference.path + '/').replace(/^.*root:\/?/, '')}${item.name}`.split('/')]
		};
	}

	static withBreadcrumbs (item: {name: string, parentReference: any}): any {
		return {
			...item,
			breadcrumbs: 
				item.parentReference.path ?
				item.parentReference.path
					.substring(item.parentReference.path.indexOf(':') +2)
					.split('/')
					.filter(item => !!item.length)
					.concat(item.name)
					.reduce((path, name) => 
						path.last ? 
						path.concat({name, parentReference: {path: `${path.last.parentReference.path}/${path.last.name}`}}):
						[{name, parentReference: {path: `root:`}}
					], [])
					.map(MicrosoftDriveService.withLink):
				[]
		};
	}
}
